import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DiagramOwner'],
});


export const diagramOwnerApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDiagramOwners: builder.query({
      query: () => `diagram_owners/`,
      keepUnusedDataFor: 0,
      providesTags: ['DiagramOwner'],
    }),
    findDiagramOwnersById: builder.query({
      query: (id) => `diagram_owners/${id}/`,
      keepUnusedDataFor: 0,
      providesTags: ['DiagramOwner'],
    }),

    createDiagramOwners: builder.mutation({
      query: (payload) => ({
        url: `diagram_owners/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['DiagramOwner'],
    }),
    deleteDiagramOwners: builder.mutation({
      query: (id) => ({
        url: `diagram_owners/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DiagramOwner'],
    }),
    updateDiagramOwners: builder.mutation({

      query: (payload) => ({
        
        url: `diagram_owners/${payload.id}/`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['DiagramOwner'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllDiagramOwnersQuery,
  useFindDiagramOwnersByIdQuery,
  useCreateDiagramOwnersMutation,
  useDeleteDiagramOwnersMutation,
  useUpdateDiagramOwnersMutation,
} = diagramOwnerApi;
